<div class="hpad-400 vpad-200 hflex-300">
  <div class="fill-flex">
    <h1 class="hflex-150 flex-align-items-center">
      <img src="assets/icons/favicon.ico" alt="meadow" />
      mdw.design-system
    </h1>
  </div>
  <div class="hflex-200 flex-align-items-center">
    <mdw-select
      [options]="familyOptions()"
      labelProperty="name"
      valueProperty="family"
      [ngModel]="family()"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="selectFamily($event)"
    ></mdw-select>
    <mdw-tab-group
      class="small-tab-group"
      [tabs]="modeTabs"
      [selectedTab]="mode()"
      (goTo)="selectMode($event)"
    ></mdw-tab-group>
  </div>
</div>
